import { render, staticRenderFns } from "./aiExamine.vue?vue&type=template&id=49fe2ac9&scoped=true"
import script from "./aiExamine.vue?vue&type=script&lang=js"
export * from "./aiExamine.vue?vue&type=script&lang=js"
import style0 from "./aiExamine.vue?vue&type=style&index=0&id=49fe2ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe2ac9",
  null
  
)

export default component.exports